import { render, staticRenderFns } from "./AssignmentStudySet.vue?vue&type=template&id=96b13dc0&scoped=true&"
import script from "./AssignmentStudySet.vue?vue&type=script&lang=js&"
export * from "./AssignmentStudySet.vue?vue&type=script&lang=js&"
import style0 from "./AssignmentStudySet.vue?vue&type=style&index=0&id=96b13dc0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "96b13dc0",
  null
  
)

export default component.exports